import { CheckBox, InputWithIcon, StyledText, Toast } from '@clickcease/cc-client-components-lib'
import { faMagnifyingGlass, faAngleUp, faAngleDown } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { WrapperWithButtons } from '../../../../../../../../components/Elements/WrapperWithButtons/WrapperWithButtons'
import { SORT_DIRECTION, SortDirection } from '../../../../../../../DomainPresentation/utils'
import {
  IdsSelectionContainer,
  IdsSelectionRow,
  InputContainer,
  MessageContainer,
  SortEntity,
  SortIcon,
} from '../../../../../common/StandardCheckboxModal/StandardCheckboxModal.styled'
import { GenericPlatformEntity } from '../../../../../../models'

import { PixelsList } from './PixelsList'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface SelectAccountIdsProps {
  options: GenericPlatformEntity[]
  selected: number[]
  title: string
  filterBy: string
  searchPlaceholder: string
  entitiesName: string
  buttonText: string
  buttonLoading?: boolean
  modalLoading?: boolean
  sortDirection: SortDirection
  handleSelect: (value: number) => void
  onSearch: (value: string) => void
  handleSelectAll: () => void
  handleSubmit: () => void
  onBack: () => void
  handleSortChange: () => void
  customInput?: React.ReactNode
  messageBox?: {
    content: ReactNode
    type: 'info' | 'warning' | 'failure'
  }
  isBackButtonDisabled?: boolean
  isReadOnly?: boolean
}

export const PixelIdsInner = ({
  options,
  selected,
  title,
  searchPlaceholder,
  filterBy,
  buttonLoading,
  modalLoading,
  buttonText,
  entitiesName,
  sortDirection,
  handleSelect,
  onSearch,
  handleSelectAll,
  handleSubmit,
  onBack,
  handleSortChange,
  customInput,
  messageBox,
  isBackButtonDisabled,
  isReadOnly,
}: SelectAccountIdsProps) => {
  const { t } = useTranslation('PMPlatforms')
  const isIdHeaderShown = options.some(
    (option) =>
      !!option.adAccountId || !!option.adAccountID || !!option.campaignId || !!option.managerId
  )

  return (
    <WrapperWithButtons
      onGhostButtonClick={onBack}
      ghostButtonText={t('back')}
      primaryButtonText={buttonText}
      onPrimaryButtonClick={handleSubmit}
      isPrimaryButtonDisabled={selected.length === 0}
      isPrimaryButtonLoading={buttonLoading}
      modalLoading={modalLoading}
      isGhostButtonDisabled={isBackButtonDisabled}
    >
      {!!messageBox && (
        <MessageContainer>
          <Toast type={messageBox.type}>
            <StyledText variant={'baseLight'}>{messageBox.content}</StyledText>
          </Toast>
        </MessageContainer>
      )}
      <StyledText variant={'baseBold'}>{title}</StyledText>
      <InputContainer>
        <InputWithIcon
          value={filterBy}
          onChange={(e) => onSearch(e.target.value)}
          iconRight={<FontAwesomeIcon icon={faMagnifyingGlass as IconProp} />}
          placeholder={searchPlaceholder}
          css={{ width: '300px' }}
        />
        {!!customInput && customInput}
      </InputContainer>
      <IdsSelectionRow header css={{ marginTop: '$8' }}>
        <CheckBox
          //isReadOnly means auto protection and should be checked
          isChecked={options.length === selected.length || !!isReadOnly}
          onChange={handleSelectAll}
          disabled={isReadOnly}
        />
        <SortEntity onClick={handleSortChange}>
          <StyledText variant={'baseBold'}>{t('name-of', { entity: entitiesName })}</StyledText>
          <SortIcon>
            <FontAwesomeIcon
              icon={
                sortDirection === SORT_DIRECTION.ASC
                  ? (faAngleUp as IconProp)
                  : (faAngleDown as IconProp)
              }
            />
          </SortIcon>
        </SortEntity>
        <StyledText variant={'baseBold'}>{isIdHeaderShown ? t('id') : ''}</StyledText>
      </IdsSelectionRow>
      <IdsSelectionContainer>
        <PixelsList
          selectedAccounts={selected}
          accountsToShow={options}
          handleSelect={handleSelect}
          isReadOnly={isReadOnly}
          sortDirection={sortDirection}
          //isReadOnly means auto protection and should be checked
          isAllSelected={isReadOnly}
        />
      </IdsSelectionContainer>
    </WrapperWithButtons>
  )
}
